(() => {
  const locale = document.documentElement.lang || 'fr';
  const ratingFormat = new Intl.NumberFormat(locale, {minimumFractionDigits: 1, maximumFractionDigits: 1});
  const countFormat = new Intl.NumberFormat(locale, {maximumFractionDigits: 0});
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const countUp = (box) => {
    const rating = parseFloat(box.dataset.rating);
    const reviews = parseInt(box.dataset.reviews, 10);
    const ratingEl = box.querySelector('.rating-count');
    const reviewsEl = box.querySelector('.reviews-count');
    const duration = parseInt(box.dataset.duration, 10) || 1500;

    const render = (progress) => {
      if (ratingEl && !Number.isNaN(rating)) ratingEl.textContent = ratingFormat.format(rating * progress);
      if (reviewsEl && !Number.isNaN(reviews)) reviewsEl.textContent = countFormat.format(Math.round(reviews * progress));
    };

    if (reducedMotion) {
      render(1);
      return;
    }

    const start = performance.now();
    const step = (now) => {
      const t = Math.min((now - start) / duration, 1);
      render(1 - Math.pow(1 - t, 3));
      if (t < 1) requestAnimationFrame(step);
    };
    render(0);
    requestAnimationFrame(step);
  };

  const show = (box) => {
    box.classList.add('is-visible');
    if (box.dataset.animated !== 'false') countUp(box);
  };

  const reveal = (root = document) => {
    const boxes = root.querySelectorAll('.rating-box:not(.is-visible)');
    if (!boxes.length) return;

    if (!('IntersectionObserver' in window)) {
      boxes.forEach(show);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          show(entry.target);
        });
      },
      {threshold: 0.3}
    );
    boxes.forEach((box) => observer.observe(box));
  };

  reveal();
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
})();
